const masterAreas = [
  {
    name: 'master-target-areas',
    icon: 'database-2'
  },
  {
    name: 'master-management-units',
    icon: 'database-2'
  },
  {
    name: 'master-regions',
    icon: 'database-2'
  },
]
const mainAms = [
  {
    name: 'ams-regions',
    parent_path: "regions",
    icon: 'map-pin-line'
  },
  {
    parent_path: "management-units",
    name: 'ams-management-units',
    icon: 'map-pin-range-line'
  },
  {
    parent_path: "target-areas",
    name: 'ams-target-areas',
    icon: 'user-location-line'
  },
  {
    parent_path: "villages",
    name: 'ams-villages',
    icon: 'pushpin-line'
  },
]
const mainAmsMangrove = [
  {
    parent_path: "management-unit-mangroves",
    name: 'ams-management-unit-mangroves',
    icon: 'map-pin-line'
  },
  {
    parent_path: "area-mangroves",
    name: 'ams-area-mangroves',
    icon: 'map-pin-range-line'
  },
  {
    parent_path: "mangrove-blocks",
    name: 'ams-mangrove-blocks',
    icon: 'user-location-line'
  },
  {
    parent_path: "mangrove-plots",
    name: 'ams-mangrove-plots',
    icon: 'pushpin-line'
  },
]

const module = {
  config: {
    name: "AMS",
    icon: "signal-tower",
    desc: "Data Pengaturan Manajemen Area pada Aplikasi",
    layout: true,
    order: 3
  },
  routes: [
    {
      name: 'area',
      type: 'parent',
      // icon: "user",
      redirectName: 'ams-regions',
      child: [
        ...mainAms.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./main-ams/${v.parent_path}/${v.name}.vue`),
            separator: null
          }
        }),
      ],
    //   [
    // {
    //   name: 'villages-ams',
    //   icon: 'pushpin',
    //   path: `/areas/villages-ams`,
    //   translate_key: 'villages-ams',
    //   // component: () => import("../masters/areas/villages.vue"),
    //   separator: ""
    //     },
    //   ]
    },
    {
      name: 'area-mangrove',
      type: 'parent',
      redirectName: 'ams-management-unit-mangroves',
      child: [
        ...mainAmsMangrove.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./main-ams-mangrove/${v.parent_path}/${v.name}.vue`),
            separator: null
          }
        }),
      ],
    },
    // Master Area
    // {
    //   name: 'master-areas',
    //   type: 'parent',
    //   redirectName: 'master-management-units',
    //   child: [
    //     ...masterAreas.flatMap(v => {
    //       return {
    //         name: v.name,
    //         icon: v.icon,
    //         path: `/${v.name}`,
    //         translate_key: v.name,
    //         component: () => import(`./master-areas/${v.name}.vue`),
    //         separator: null
    //       }
    //     }),
    //   ],
    // },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/AMS/_index.js